<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}
</style>
<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page :title="' Laporan Lejar'">
            <w-flex justify-center align-center>
                <div class="xs4">
                    <h5 class="fw-semibold m0">
                        Akaun :
                    </h5>
                    <div class="fw-normal my1 fs-1"> {{decodeURI(this.cari.akaun)}} </div>
                </div>
                
                <div class="xs4">
                    <h5 class="fw-semibold m0">
                        Tarikh Dari :
                    </h5>
                    <!-- <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(form.created_at)}}</div> -->
                    <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(this.cari.tarikh_dari)}}</div>
                </div>
                <div class="xs4">
                    <h5 class="fw-semibold m0">
                        Tarikh Hingga :
                    </h5>
                    <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(this.cari.tarikh_hingga)}}</div>
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button class="ml1" v-on:click="goback()" bg-color="success">
                        <w-icon>fal fa-arrow-left</w-icon>&nbsp;Kembali
                    </w-button>
                </div>
            </w-flex>
            <center v-if="loading == true"><w-progress class="ma1" circle></w-progress></center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>TARIKH</td>
                                <td>NO DOKUMEN</td>
                                <td>KETERANGAN</td>
                                <td>AMAUN DEBIT (RM)</td>
                                <td>AMAUN KREDIT (RM)</td>
                                <td>TINDAKAN</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="table.data">
                                <template v-for="(dt, index) in table.data">
                                    <tr>
                                        <td>{{ dt.tarikh_dmY }}</td>
                                        <td>{{ dt.no_dokumen }}</td>
                                        <td>{{ dt.keterangan }}</td>
                                        <td style="text-align: right">{{ dt.debit_rm }}</td>
                                        <td style="text-align: right">{{ dt.kredit_rm }}</td>
                                        <td style="text-align: center"><w-icon tile v-on:click="showModal(dt.id)">fal fa-eye</w-icon></td>
                                    </tr>
                                </template>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="5" style="text-align: center">Tiada Rekod</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <w-card class="text-right">
                        <w-flex v-if="table.current_page"
                            class="justify-start align-center"
                        >
                            <pagination
                                class="xs11"
                                :max="table.last_page"
                                :path="table.path"
                                :current="table.current_page"
                                :last_page="table.last_page"
                                :links="table.links"
                                @pageChanged="table.loadpg"
                            />
                        </w-flex>
                    </w-card>
                </div>
            </w-flex>
            <!-- <center v-if="!table.meta.current_page"><w-progress class="ma1" circle></w-progress></center>
            <z-table
                ref="tbluser"
                title=""
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
            </z-table> -->

            <w-dialog v-model="modal.show" :fullscreen="modal.fullscreen" :width="modal.width" :persistent="modal.persistent" :persistent-no-animation="modal.persistentNoAnimation" title-class="primary-light1--bg white">
                <template #title>
                     Paparan Jernal
                </template>
                <template #default>
                     <w-form ref="form">
                        
                        <w-flex class="mt3">
                          <div class="xs4">
                              <h5 class="fw-semibold m0">
                                  No. Jurnal :
                              </h5>
                              <div class="fw-normal my1 fs-1"> {{ form.no_jurnal }} </div>
                          </div>
                          <div class="xs4">
                              <h5 class="fw-semibold m0">
                                  No. Dokumen :
                              </h5>
                              <div class="fw-normal my1 fs-1"> {{ form.no_dokumen }} </div>
                          </div>
                          <div class="xs4">
                              <h5 class="fw-semibold m0">
                                  Keterangan :
                              </h5>
                              <div class="fw-normal my1 fs-1"> {{ form.keterangan }} </div>
                          </div>
                        </w-flex>

                        <w-flex class="mt3">
                          <div class="xs4">
                              <h5 class="fw-semibold m0">
                                  Catatan :
                              </h5>
                              <div class="fw-normal my1 fs-1"> {{ form.catatan }} </div>
                          </div>
                          <div class="xs4">
                              <h5 class="fw-semibold m0">
                                 
                              </h5>
                              <div class="fw-normal my1 fs-1"> </div>
                          </div>
                          <div class="xs4">
                             
                          </div>
                        </w-flex>
                            <table class="w-table">
                                <thead>
                                <tr>
                                    <th class="w-table__header w-table__header--sortable text-left">Kod Akaun</th>
                                    <th class="w-table__header w-table__header--sortable text-left">Amaun Debit (RM)</th>
                                    <th class="w-table__header w-table__header--sortable text-left">Amaun Kredit (RM)</th>
                                </tr>
                                </thead>
                                <tbody>
                                
                                    <tr v-for="dt, index in form.jurnal_akaun">
                                        <td class="w-table__cell text-left">
                                            {{dt.akaun_kod}} | {{dt.akaun_keterangan}}
                                        </td>
                                        <td class="w-table__cell text-right">
                                            {{$zutil.currency(dt.amaun_debit)}}
                                        </td>
                                        <td class="w-table__cell text-right">
                                            {{$zutil.currency(dt.amaun_kredit)}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="w-table__cell text-left">Jumlah</th>
                                        <th class="w-table__cell text-right" >{{$zutil.currency(total_debit)}}</th>
                                        <th class="w-table__cell text-right" >{{$zutil.currency(total_kredit)}}</th>
                                    </tr>
                                </tbody>
                                
                            </table>
                        
                    </w-form>
                </template>
                <template #actions>
                  <div class="spacer" />
                    <w-button bg-color="grey-light5--bg" @click="modal.show = false">Tutup</w-button>
                </template>
            </w-dialog>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
        id: [Array, Object, String],
    },
    data() {
        return {
            resourceurl: this.service_utiliti + "lejar",
            reload: true,
            loading: false,
            status: [
                {
                    value: 1,
                    label: "Aktif",
                },
                {
                    value: 2,
                    label: "Tidak Aktif",
                },
            ],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Utiliti", route: "/utiliti/laporan/"},
                { label: "Laporan", route: "/utiliti/laporan/lejar"},
                {
                    label: "Laporan Lejar",
                    route: "/utiliti/laporan/lejar",
                },
            ],
            tabs: [
                { title: 'Butiran', content: '' },
                { title: 'Jejak Audit', content: '' },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", akaun_id: "", amaun_debit: "", amaun_kredit: "",  akaun: ""},
            total_debit: 0,
            total_kredit: 0,
            modal: {show: false}
        };
    },
    methods: {
        search() {
            this.getDataQuery();
        },
        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", akaun_id: "", amaun_debit: "", amaun_kredit: "",  akaun: ""};
            this.search();
        },
        goback() {
            this.$inertia.visit(window.route('utiliti.laporan.lejar')+'?tarikh_dari='+this.cari.tarikh_dari+'&tarikh_hingga='+this.cari.tarikh_hingga+'&goback=true', {preserveScroll:true})
        },
        cetak() {
            window.open(this.service_utiliti+'lejar/'+this.id+'?user_id='+this.auth.user.id+'&cetak=true'+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga +
            "&akaun_id=" + this.cari.akaun_id +
            "&amaun_debit=" + this.cari.amaun_debit +
            "&amaun_kredit=" + this.cari.amaun_kredit +
            "&akaun=" + this.cari.akaun,'_blank');
        },
        showModal(idx) {
            this.getDataLv3(idx)
            this.modal.show = true;
        },
        async getDataQuery() {
            this.loading = true;
            const resp = await axios.get(
                this.service_utiliti + "lejar/"+this.id+"?user_id=" + this.auth.user.id +
                    "&tarikh_dari=" + this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga +
                    "&akaun_id=" + this.cari.akaun_id +
                    "&amaun_debit=" + this.cari.amaun_debit +
                    "&amaun_kredit=" + this.cari.amaun_kredit +
                    "&akaun=" + this.cari.akaun
            );
            this.table = resp.data.lejar;
            this.modal.show = false;
            this.loading = false;
        },
        async getDataLv3(idx) {
            this.loading = true;
            var resp = await axios.get(
                this.service_utiliti + "jurnal/"+idx
            );
            this.form = resp.data;
            this.totalDebitKredit()
            this.loading = false;
        },
        totalDebitKredit(){
            this.total_kredit = 0;
            this.total_debit = 0;
            for (var i in this.form.jurnal_akaun) {
                if(this.form.jurnal_akaun[i].amaun_debit){
                    this.total_debit = this.total_debit + parseFloat(this.form.jurnal_akaun[i].amaun_debit);
                }
                if(this.form.jurnal_akaun[i].amaun_kredit){
                    this.total_kredit = this.total_kredit + parseFloat(this.form.jurnal_akaun[i].amaun_kredit);
                }
            }
        },
    },
    watch: {},
    mounted() {
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.akaun_id == "undefined") {
            this.cari.akaun_id = "";
        }
        this.getDataQuery();
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
